export default __webpack_public_path__ + "static/media/casino.c9610ac3.png";